module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-02.9e016e78.jpg";